export const APPLE_CERTIFICATE_STATUS = {
    'Installed': 'Apple certificate installed',
    'Not Installed': 'Apple certificate not installed',
    'Expired': 'Apple certificate has expired',
    'Processing': 'Apple certificate in process',
    'Nearing expiration': 'Apple certificate nearing expiration'
};
